import React, { useState } from "react";
import { useLang } from "../../context/LangContext";

export default function HowItWorks() {
  const { c } = useLang();
  const h = c.how;
  const [tab, setTab] = useState("Investors");
  const tabKeys = ["Investors", "Realtors", "Builders"];
  return (
    <section id="how" className="section">
      <div className="container-x">
        <div className="reveal">
          <span className="eyebrow">{h.eyebrow}</span>
          <h2 className="display" style={{ fontSize: "clamp(2.2rem,5vw,4rem)", maxWidth: 720, margin: "1.2rem 0 1.6rem" }}>
            {h.title.pre}<span className="italic-gold">{h.title.em}</span>{h.title.post}
          </h2>
          <p className="body-text" style={{ maxWidth: 640, marginBottom: "2.5rem" }}>{h.para}</p>

          <div style={{ display: "inline-flex", gap: "0.4rem", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 999, padding: "0.35rem", marginBottom: "3rem", flexWrap: "wrap" }}>
            {tabKeys.map((t) => (
              <button key={t} onClick={() => setTab(t)} style={{ padding: "0.55rem 1.5rem", borderRadius: 999, border: "none", cursor: "pointer", fontSize: "0.72rem", letterSpacing: "0.14em", textTransform: "uppercase", transition: "all 0.25s ease", background: tab === t ? "var(--gold)" : "transparent", color: tab === t ? "#17130a" : "var(--muted)", fontWeight: tab === t ? 500 : 400 }}>{h.tabs[t]}</button>
            ))}
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "1.5rem" }}>
          {h.data[tab].map((item) => (
            <div key={item.n} className="card reveal" style={{ padding: "2.2rem" }}>
              <div className="font-serif" style={{ fontSize: "2.4rem", color: "var(--gold)", opacity: 0.5, marginBottom: "1rem" }}>{item.n}</div>
              <h3 className="font-serif" style={{ fontSize: "1.4rem", marginBottom: "0.9rem", color: "var(--text)" }}>{item.t}</h3>
              <p className="body-text" style={{ fontSize: "0.92rem" }}>{item.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
